import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule, HttpClient }    from '@angular/common/http';
import { FormsModule, ReactiveFormsModule }    from '@angular/forms';
import { QRCodeModule } from 'angular2-qrcode';
import { NgxEchartsModule } from 'ngx-echarts';
import * as echarts from 'echarts';

import { DataService } from './data.service'
import { ExcelService } from './excel.service'

import { AppRoutingModule } from './/app-routing.module';
import { AuthGuard } from './auth.guard';

import {MatButtonModule, MatCheckboxModule, MatSidenavModule, MatDialogModule, 
  MatInputModule, MatTableModule, MatPaginatorModule, MatSortModule,
  MatSelectModule, MatOptionModule, MatDatepickerModule, MatNativeDateModule,
  MatRadioModule, MatSlideToggleModule, MatSliderModule, MatAutocompleteModule } from '@angular/material';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { TopComponent } from './top/top.component';
import { PopupComponent } from './popup/popup.component';
import { ProductoComponent } from './producto/producto.component';
import { DescuentoComponent } from './descuento/descuento.component';
import { DescuentoEditComponent } from './descuento-edit/descuento-edit.component';
import { ProductoEditComponent } from './producto-edit/producto-edit.component';
import { UltimosTicketsComponent } from './reportes/ultimos-tickets/ultimos-tickets.component';
import { ImprimeTicketComponent } from './imprime-ticket/imprime-ticket.component';
import { CategoriaComponent } from './categoria/categoria.component';
import { CategoriaEditComponent } from './categoria-edit/categoria-edit.component';
import { MonedaComponent } from './moneda/moneda.component';
import { MonedaEditComponent } from './moneda-edit/moneda-edit.component';
import { FormaPagoComponent } from './forma-pago/forma-pago.component';
import { FormaPagoEditComponent } from './forma-pago-edit/forma-pago-edit.component';
import { ArqueoComponent } from './arqueo/arqueo.component';
import { RecuperaMailComponent } from './recupera-mail/recupera-mail.component';
import { AfluenciaComponent } from './reportes/afluencia/afluencia.component';
import { CancelaTicketComponent } from './cancela-ticket/cancela-ticket.component';
import { SistemaComponent } from './sistema/sistema.component';
import { CancelacionesComponent } from './reportes/cancelaciones/cancelaciones.component';
import { IndicadoresSAACComponent } from './reportes/indicadores-saac/indicadores-saac.component';
import { IndicadoresTaquillaComponent } from './reportes/indicadores-taquilla/indicadores-taquilla.component';
import { IndicadoresSISCComponent } from './reportes/indicadores-sisc/indicadores-sisc.component';
import { TiendaComponent } from './tienda/tienda.component';
import { IngresosComponent } from './ingresos/ingresos.component';
import { IngresoComponent } from './reportes/ingreso/ingreso.component';
import { MetasComponent } from './metas/metas.component';
import { MetasEditComponent } from './metas-edit/metas-edit.component';
import { UsuariosComponent } from './usuarios/usuarios.component';
import { UsuariosEditComponent } from './usuarios-edit/usuarios-edit.component';
import { CambioPwdComponent } from './cambio-pwd/cambio-pwd.component';
import { ValidaQrComponent } from './valida-qr/valida-qr.component';
import { AccesoQRComponent } from './acceso-qr/acceso-qr.component';
import { EditaFormaComponent } from './edita-forma/edita-forma.component';
import { PresConceptosComponent } from './pres-conceptos/pres-conceptos.component';
import { PresMovimientosComponent } from './pres-movimientos/pres-movimientos.component';
import { PresConceptosEditComponent } from './pres-conceptos-edit/pres-conceptos-edit.component';
import { NotaVentaComponent } from './reportes/nota-venta/nota-venta.component';
import { PresMovimientosDetComponent } from './pres-movimientos-det/pres-movimientos-det.component';
import { BaseComponent } from './reportesPres/base/base.component';
import { ValidaQrZebraComponent } from './valida-qr-zebra/valida-qr-zebra.component';
import { PrivAudioComponent } from './priv-audio/priv-audio.component';
import { AcepPolPrivComponent } from './acep-pol-priv/acep-pol-priv.component';
import { ServiciosTelmexComponent } from './servicios-telmex/servicios-telmex.component';
import { GrafupComponent } from './paginas/grafup/grafup.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    TopComponent,
    PopupComponent,
    ProductoComponent,
    DescuentoComponent,
    DescuentoEditComponent,
    ProductoEditComponent,
    UltimosTicketsComponent,
    ImprimeTicketComponent,
    CategoriaComponent,
    CategoriaEditComponent,
    MonedaComponent,
    MonedaEditComponent,
    FormaPagoComponent,
    FormaPagoEditComponent,
    ArqueoComponent,
    RecuperaMailComponent,
    AfluenciaComponent,
    CancelaTicketComponent,
    SistemaComponent,
    CancelacionesComponent,
    IndicadoresSAACComponent,
    IndicadoresTaquillaComponent,
    IndicadoresSISCComponent,
    TiendaComponent,
    IngresosComponent,
    IngresoComponent,
    MetasComponent,
    MetasEditComponent,
    UsuariosComponent,
    UsuariosEditComponent,
    CambioPwdComponent,
    ValidaQrComponent,
    AccesoQRComponent,
    EditaFormaComponent,
    PresConceptosComponent,
    PresMovimientosComponent,
    PresConceptosEditComponent,
    NotaVentaComponent,
    PresMovimientosDetComponent,
    BaseComponent,
    ValidaQrZebraComponent,
    PrivAudioComponent,
    AcepPolPrivComponent,
    ServiciosTelmexComponent,
    GrafupComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatButtonModule,
    MatCheckboxModule,
    MatSidenavModule,
    MatDialogModule,
    MatInputModule,
    MatAutocompleteModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatSelectModule,
    MatOptionModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatRadioModule,
    MatSlideToggleModule,
    MatSliderModule,
    BrowserAnimationsModule,
    QRCodeModule,
    NgxEchartsModule.forRoot({echarts}),
    //PdfViewerModule 
  ],
  providers: [
    DataService,
    ExcelService,
    AuthGuard,
    ],
  bootstrap: [AppComponent]
})
export class AppModule { }
